import React from 'react';

import { Badge, MenuItem, Popover, Stack, Typography } from '@mui/material';

import { LogModuleChecklist } from './LogModuleChecklist';

interface Props {
  shouldShowModule: Map<string, boolean>;

  onChange: (modules: Map<string, boolean>) => void;
}

interface State {
  isOpen: boolean;
}

export class LogModuleChecklistMenuItem extends React.Component<Props, State> {
  private anchorElement = React.createRef<HTMLLIElement>();

  constructor(props: Props) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }

  private enabledModulesCountForBadge() {
    const enabledModules = Array.from(this.props.shouldShowModule.values()).filter((v) => v).length;
    const totalModules = this.props.shouldShowModule.size;
    if (totalModules === enabledModules) {
      return null;
    }
    return enabledModules;
  }

  render() {
    return [
      <MenuItem
        key="0"
        ref={this.anchorElement}
        onClick={() => {
          this.onClick();
        }}
      >
        <Badge
          badgeContent={this.enabledModulesCountForBadge()}
          color="secondary"
          showZero
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
        >
          <Typography textAlign="center">Filter by modules</Typography>
        </Badge>
      </MenuItem>,
      <Popover
        key="1"
        open={this.state.isOpen}
        anchorEl={this.anchorElement.current}
        onClose={() => {
          this.onClose();
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Stack direction="column" spacing={1}>
          <LogModuleChecklist
            shouldShowModule={this.props.shouldShowModule}
            onChange={(modules) => {
              this.onChange(modules);
            }}
          />
        </Stack>
      </Popover>,
    ];
  }

  private onChange(modules: Map<string, boolean>) {
    this.props.onChange(modules);
  }

  private onClick() {
    this.setState({ isOpen: true });
  }

  private onClose() {
    this.setState({ isOpen: false });
  }
}
